export default __webpack_public_path__ + "static/media/bj.13908532.svg";